module.exports = "/packs/done_block_sp-e2454469e342c8b735a36144a202bc34.png";